import { fetchReducerGenerator } from 'redpoints-front-common/reducers';

import {
  INCIDENT_DETAILS_CLEAR,
  INCIDENT_DETAILS_FETCH_CONTENT_LINK_RELATED_ADS,
} from '../../../../actions/actionTypes';

const relatedAds = fetchReducerGenerator(
  INCIDENT_DETAILS_CLEAR,
  INCIDENT_DETAILS_FETCH_CONTENT_LINK_RELATED_ADS
);

export default relatedAds;
